<ng-template #content let-modal>
  <div class="sticky">
    
  {{i18n['shp.common.headerText']}}
  <button style="float: right;cursor: pointer;
  color: white;background-color: transparent;
 border: transparent;font-weight: bolder; padding-right: 20px; font-size:19px;" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
  </div>
  <div class="modal-body">    
      <div class="success_msg">
        <div *ngIf="modifyPwdSuccess" class="alert alertMessage">
          {{successMsg}}
        </div>
      </div>
      <div class="failure_msg ml-6">
        <div *ngIf="modifyPwdIsFailed" class="alert alertMessage p-0">
          {{failureMsg}}
        </div>
        </div>
    
<form  #modifypwdForm="ngForm" class="form_align passwordScreen" name="modifypwdform">
  <div class="form-group" *ngIf="modifyPwdSuccess==false">
    <div class="oldpwd">
    <label for="oldPassword" class="label_align">{{i18n['shp.common.oldPassword']}}</label><span class="sp">*</span>
    <input ngModel name="password" type="password" id="password" #password="ngModel"  class="form-control" required=true/>
    <div class="validation_style" *ngIf="password.dirty && !password.valid" id="password_validation">{{i18n['shp.common.oldpasswordvalidation']}}</div>
  </div>
  </div>  
<div class="form-group" *ngIf="modifyPwdSuccess==false">
  <div class="newpwd">
  <label for="newPassword" class="label_align1">{{i18n['shp.common.newPassword']}}</label><span class="sp">*</span>
  <input ngModel name="newpassword" type="password" id="newpassword" #newpassword="ngModel" class="form-control"  minlength="{{passwordLength}}" pattern="{{ValidationPattern}}"
  required>
  <div class="validation_style" *ngIf="newpassword.touched && !newpassword.valid" id="newpwd-validation">{{errorMessage}}</div>
</div>
</div>
  <div class="form-group" *ngIf="modifyPwdSuccess==false">
    <div class="confirmpwd">
    <label for="confirmPassword" class="label_align2">{{i18n['shp.common.confirmPassword']}}</label><span class="sp">*</span>
    <input ngModel name="confirmpassword" type="password" ngValidateEqual="newpassword" id="confirmpassword" #confirmpassword="ngModel" class="form-control" required>
    <div class="validation_style" *ngIf="confirmpassword.touched && !confirmpassword.valid" id="cnfpwd_validation">{{i18n['shp.passwordReset.error']}}</div>
    <div class="validation_style" *ngIf="confirmpassword.dirty && modifypwdForm.value.newpassword !== modifypwdForm.value.confirmpassword && modifypwdForm.value.confirmpassword !==''" id="cnfpwd_validation">{{i18n['shp.passwordReset.error']}}</div>
  </div>
</div>
<div class="btn-align mobileSubmit" *ngIf="modifyPwdSuccess==false">
  <button (click)="modifyPassword(modifypwdForm)"  class="btn btn-primary btn" [disabled]="modifypwdForm.invalid ||  modifypwdForm.value.newpassword !== modifypwdForm.value.confirmpassword">Submit</button>
  </div>
</form>
</div>
</ng-template>

